import { inject, ref, onMounted } from 'vue'

export function useFormFieldPrefillForMultipleChoiceWithCustom(uuid, initialValue, options) {
    const fieldValue = ref(initialValue.value || [])
    const prefillValues = inject('formPrefillValues', ref(null))

    const preFill = () => {
        if (prefillValues.value && prefillValues.value[uuid]?.value !== undefined) {
            const prefillAnswers = prefillValues.value[uuid].value

            // Filter out any custom answers that don't match the options
            const customAnswers = prefillAnswers.filter(value =>
                !options.some(option => option.value === value)
            )

            // Set the field value to include both matching options and custom answers
            fieldValue.value = prefillAnswers
        }
    }

    onMounted(() => {
        preFill()
    })

    return {
        fieldValue
    }
}
